import React, { useState, useEffect } from 'react';
import '../Preloader.css'; // Ensure this path is correct

const Preloader = () => {
  const [controlStage, setControlStage] = useState('close'); // Start with 'close'

  useEffect(() => {
    // Set timers for each stage of control display
    const timers = [
      setTimeout(() => setControlStage('minimize'), 1600), // After 1.6 seconds, show 'minimize'
      setTimeout(() => setControlStage('maximize'), 3200), // After 3.2 seconds, show 'maximize'
      setTimeout(() => setControlStage('close'), 4500),      // After 4.8 seconds, hide controls (for smooth transition)
    ];

    // Cleanup timers on component unmount
    return () => timers.forEach(timer => clearTimeout(timer));
  }, []);

  return (
    <div className="preloader-container flex justify-center min-h-screen bg-black">
      <div className="terminal-loader">
        <div className="terminal-header">
          <div className="terminal-title">Status</div>
          <div className="terminal-controls">
            {controlStage === 'close' && <div className="control close"></div>}
            {controlStage === 'minimize' && <div className="control minimize"></div>}
            {controlStage === 'maximize' && <div className="control maximize"></div>}
          </div>
        </div>
        <div className="text">Loading...</div>
      </div>
    </div>
  );
};

export default Preloader;
